// console.log('It Works!!!');

/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/common/common.js":
/*!*********************************!*\
  !*** ./src/js/common/common.js ***!
  \*********************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

    __webpack_require__.r(__webpack_exports__);
    var Common = function () {
      var pressESC = function pressESC() {
        document.addEventListener('keyup', function (ev) {
          if (ev.keyCode === 27) {}
        });
      };
    
      var clickBody = function clickBody() {
        document.body.addEventListener('click', function (ev) {
          var className = "body";
    
          if (!ev.target.closest(className).length) {}
        });
      };
    
      var preventBehavior = function preventBehavior() {
        var link = document.querySelectorAll("a");
        link.forEach(function (val, idx) {
          val.addEventListener("click", function (ev) {
            if (val.getAttribute("href") === "#") {
              ev.preventDefault();
            }
          });
        });
      };
    
      var initLoad = function initLoad() {
        pressESC();
        clickBody();
        preventBehavior();
      };
    
      return {
        initLoad: initLoad
      };
    }();
    
    /* harmony default export */ __webpack_exports__["default"] = (Common);
    
    /***/ }),
    
    /***/ "./src/js/macros/hamburger.js":
    /*!************************************!*\
      !*** ./src/js/macros/hamburger.js ***!
      \************************************/
    /***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
    
    __webpack_require__.r(__webpack_exports__);
    var Hamburger = function () {
      var init = function init() {
        if (!document.querySelector('[hamburger-js]')) return;
        document.querySelectorAll('[hamburger-js]').forEach(function (val) {
          val.addEventListener('click', function (ev) {
            var el = ev.currentTarget,
                documentMainTags = document.querySelectorAll('html, body'),
                mobileContainer = document.querySelector("[mobile-block-js]");
            document.querySelectorAll('[hamburger-js]').forEach(function (val) {
              return val.classList.toggle('is-active');
            });
    
            if (mobileContainer.classList.contains("is-open")) {
              mobileContainer.classList.remove("is-open");
              mobileContainer.classList.add("is-animated");
              setTimeout(function () {
                return mobileContainer.classList.remove("is-animated");
              }, 300);
            } else {
              mobileContainer.classList.add("is-open");
            }
    
            documentMainTags.forEach(function (val, idx) {
              return val.classList.toggle('is-hideScroll');
            });
          }, false);
        });
      };
    
      return {
        init: init
      };
    }();
    
    /* harmony default export */ __webpack_exports__["default"] = (Hamburger);
    
    /***/ }),
    
    /***/ "./src/js/macros/menu.js":
    /*!*******************************!*\
      !*** ./src/js/macros/menu.js ***!
      \*******************************/
    /***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
    
    __webpack_require__.r(__webpack_exports__);
    var Menu = function () {
      var init = function init() {
        $('.menu__btn').hover(function (ev) {
          var el = $(ev.currentTarget),
              elID = el.attr('data-id');
    
          if ($(window).width() >= 768) {
            $('.menu__btn').removeClass('is-hover');
            el.addClass('is-hover');
            $('.menu__content').hide();
            $('.menu__content[data-content-id="' + elID + '"]').fadeIn(350);
          }
        }, function (ev) {});
        $('.menu__content-wrapper').hover(function (ev) {}, function (ev) {
          if ($(window).width() >= 768) {
            $('.menu__btn').removeClass('is-hover');
            $('.menu__content').hide();
          }
        });
      };
    
      return {
        init: init
      };
    }();
    
    /* harmony default export */ __webpack_exports__["default"] = (Menu);
    
    /***/ })
    
    /******/ 	});
    /************************************************************************/
    /******/ 	// The module cache
    /******/ 	var __webpack_module_cache__ = {};
    /******/ 	
    /******/ 	// The require function
    /******/ 	function __webpack_require__(moduleId) {
    /******/ 		// Check if module is in cache
    /******/ 		var cachedModule = __webpack_module_cache__[moduleId];
    /******/ 		if (cachedModule !== undefined) {
    /******/ 			return cachedModule.exports;
    /******/ 		}
    /******/ 		// Create a new module (and put it into the cache)
    /******/ 		var module = __webpack_module_cache__[moduleId] = {
    /******/ 			// no module.id needed
    /******/ 			// no module.loaded needed
    /******/ 			exports: {}
    /******/ 		};
    /******/ 	
    /******/ 		// Execute the module function
    /******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
    /******/ 	
    /******/ 		// Return the exports of the module
    /******/ 		return module.exports;
    /******/ 	}
    /******/ 	
    /************************************************************************/
    /******/ 	/* webpack/runtime/make namespace object */
    /******/ 	!function() {
    /******/ 		// define __esModule on exports
    /******/ 		__webpack_require__.r = function(exports) {
    /******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
    /******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
    /******/ 			}
    /******/ 			Object.defineProperty(exports, '__esModule', { value: true });
    /******/ 		};
    /******/ 	}();
    /******/ 	
    /************************************************************************/
    var __webpack_exports__ = {};
    // This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
    !function() {
    /*!***********************!*\
      !*** ./src/js/app.js ***!
      \***********************/
    __webpack_require__.r(__webpack_exports__);
    /* harmony import */ var _common_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./common/common */ "./src/js/common/common.js");
    /* harmony import */ var _macros_hamburger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./macros/hamburger */ "./src/js/macros/hamburger.js");
    /* harmony import */ var _macros_menu__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./macros/menu */ "./src/js/macros/menu.js");
    
    
    
    // faq
    var faqToggle = function faqToggle() {
      $('.faq__collapse-head').on('click', function (ev) {
        $(ev.currentTarget).toggleClass('is-active');
        $(ev.currentTarget).siblings('.faq__collapse-body').slideToggle(350);
      });
    };
    
    // reviews slider
    var reviewsSlider = function reviewsSlider() {
      new Swiper('.reviews__carousel .swiper', {
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        loop: true,
        speed: 1250,
        slidesPerView: 1,
        spaceBetween: 25,
        navigation: {
          nextEl: '.reviews__navigation--next',
          prevEl: '.reviews__navigation--prev'
        },
        on: {
          init: function init(swiper) {
            $(swiper.$el).css('opacity', '1');
          }
        }
      });
    };
    
    
    window.addEventListener('load', function (ev) {
      // gsap.registerPlugin(ScrollTrigger);
      // COMMON
      _common_common__WEBPACK_IMPORTED_MODULE_0__["default"].initLoad();
      _macros_menu__WEBPACK_IMPORTED_MODULE_2__["default"].init();
      _macros_hamburger__WEBPACK_IMPORTED_MODULE_1__["default"].init();


      // header animation
      window.addEventListener("scroll",function(){
        if (window.scrollY > 40) {
          $('#header').addClass('is-fill');
        } else {
          $('#header').removeClass('is-fill');
        }
      });
      
      // Animate on scroll
      const animations = document.querySelectorAll('[data-aos]');
      const observedClass = 'js-intersection-observed';
      const observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
              const index = Array.from(animations).indexOf(entry.target);
              if (entry.isIntersecting) {
                  animations[index].classList.add(observedClass);
              }
          })
      }, {
          threshold: 0
      });

      // Start the observer
      animations.forEach(animation => {
          observer.observe(animation);
      });

      // faq and review slider init
      faqToggle();
      reviewsSlider(); // MACROS

    }, false); // EVENT LISTENER - SCROLL
    // ========================================
    
    window.addEventListener('scroll', function (ev) {}, false);
    }();
    /******/ })()
    ;
